import styled from "styled-components";
import { Badge } from "react-bootstrap";

const ChannelBadge = styled(Badge)`
  background-color: var(--aa-channel-bg) !important;
  color: var(--aa-channel-color) !important;
  font-family: monospace;
  font-weight: normal;
  font-size: 12px !important;
`;

export const Channel = ({ channel }: { channel: string }) => {
  return <ChannelBadge bg="secondary">{channel}</ChannelBadge>;
};

export const Channels = ({
  channels,
  className,
}: {
  channels?: string[] | null;
  className?: string;
}) => {
  return channels?.length ? (
    <div
      className={`d-flex flex-wrap gap-1${className ? ` ${className}` : ""}`}
    >
      {channels?.map((channel) => (
        <Channel key={channel} channel={channel} />
      ))}
    </div>
  ) : null;
};
